import dimensionTooltips from '@/domains/pages/ai-proficiency/copy/dimension-tooltips.json';

/**
 * Extended "what is this behavior" copy for the six methodology dimensions, kept in JSON
 * so the wording can be edited without touching components. Keys match
 * `METHODOLOGY_DIMENSIONS[].key`.
 */
const DIMENSION_TOOLTIPS: Partial<Record<string, string>> = dimensionTooltips.dimensions;

/** Falls back to the short description when a dimension has no extended copy yet. */
export function getDimensionTooltip(key: string, fallback?: string): string | undefined {
  return DIMENSION_TOOLTIPS[key] ?? fallback;
}
